module.exports = __webpack_public_path__ + "static/media/Logo1.a8885936.png";